module.exports = __webpack_public_path__ + "static/media/clock.6cce3057.svg";